import './Title.css'
const Title = () => {
    return (
        <>
            <div className="title-font">Aura Portal</div>
        </>
    )
}
export default Title; 